export const SET_APPLICATIONS = 'SET_APPLICATIONS';
export const CLEAR_APPLICATIONS = 'CLEAR_APPLICATIONS';
export const SET_CURRENT_APPLICATION = 'SET_CURRENT_APPLICATION';
export const CLEAR_CURRENT_APPLICATION = 'CLEAR_CURRENT_APPLICATION';

export const clearApplications = {
  type: CLEAR_APPLICATIONS,
}

export const clearCurrentApplication = {
  type: CLEAR_CURRENT_APPLICATION
}

export const setApplications = (data) => {
  return {
    type: SET_APPLICATIONS,
    payload: data,
  }
}

export const setCurrentApplication = (data) => {
  return {
    type: SET_CURRENT_APPLICATION,
    payload: data,
  }
}